// Сторонние вендоры, которых Контроль заводит через /foreign_intercoms (gorod_expert).
// Ключ совпадает с model_config.identifier в edge-store и intercom_kind в gorod_expert
// (в нижнем регистре), label — с model_config.name, которое приходит в поле model устройств.
export const THIRD_PARTY_VENDORS = {
  beward: {
    label: 'Beward',
    series: [{ value: 'dks', label: 'DKS' }],
    // Панель с камерой: RTSP обязателен.
    hasCamera: true,
    // Beward подключается только по IPv4:порт, пароль API — не короче 6 символов.
    address: 'ipv4',
    passwordMinLength: 6,
  },
  eltex: {
    label: 'Eltex',
    series: [
      { value: 'ipa-er-010', label: 'IPA-ER-010' },
      { value: 'ipa-er-011', label: 'IPA-ER-011' },
    ],
    // Контроллер СКУД: камеры нет (в Асгарде заглушка), клавиатуры и кодов тоже.
    hasCamera: false,
    // Адрес может быть хостом: auth.address в Асгарде — socket address.
    address: 'host',
    // Заводские учётные данные контроллера — admin/admin, ограничения на длину нет.
    passwordMinLength: 1,
  },
}

export const passwordSchema = (yupString, kind, t) => {
  const min = THIRD_PARTY_VENDORS[kind]?.passwordMinLength || 1
  const base = yupString.required(t('common:field.error.required'))
  return min > 1
    ? base.min(min, t('common:field.error.too_short', { min }))
    : base
}

export const thirdPartyIntercomKinds = Object.keys(THIRD_PARTY_VENDORS)

// model приходит как model_config.name («Beward», «Eltex») либо как intercom_kind
// («BEWARD», «ELTEX») из /foreign_intercoms — сравниваем без учёта регистра.
export const deviceVendor = (model) => {
  const key = model?.toLowerCase()
  return thirdPartyIntercomKinds.includes(key) ? key : null
}

export const vendorConfig = (model) =>
  THIRD_PARTY_VENDORS[deviceVendor(model)] || null

export const isBeward = (model) => deviceVendor(model) === 'beward'

export const isEltex = (model) => deviceVendor(model) === 'eltex'

export const isThirdParty = (serial_number, type, model) => {
  if (type === 'camera') {
    return serial_number?.slice(0, 2) === 'DC'
  }
  return deviceVendor(model) !== null
}
